// Códigos de categoría de comercio (MCC, ISO 18245) para la afiliación PayFac.
// Se envían en la plantilla de onboarding a LAFISE (columna MCC y "Describir actividad comercial").
export interface MccCode {
    code: string;
    description: string;
}

export const mccCodes: MccCode[] = [
    { code: '0742', description: 'Servicios veterinarios' },
    { code: '0763', description: 'Cooperativas agrícolas' },
    { code: '0780', description: 'Servicios de jardinería y paisajismo' },
    { code: '1520', description: 'Contratistas generales – residencial y comercial' },
    { code: '1711', description: 'Contratistas de calefacción, plomería y aire acondicionado' },
    { code: '1731', description: 'Contratistas eléctricos' },
    { code: '1740', description: 'Contratistas de mampostería, enyesado, azulejos y aislamiento' },
    { code: '1750', description: 'Contratistas de carpintería' },
    { code: '1761', description: 'Contratistas de techos, revestimientos y láminas metálicas' },
    { code: '1771', description: 'Contratistas de concreto' },
    { code: '1799', description: 'Contratistas especializados (otros)' },
    { code: '2741', description: 'Publicaciones e impresión misceláneas' },
    { code: '2791', description: 'Tipografía, fotograbado y servicios relacionados' },
    { code: '2842', description: 'Preparaciones especiales de limpieza y pulido' },
    { code: '4011', description: 'Ferrocarriles – carga' },
    { code: '4111', description: 'Transporte local y suburbano de pasajeros, incluye ferris' },
    { code: '4112', description: 'Ferrocarriles de pasajeros' },
    { code: '4119', description: 'Servicios de ambulancia' },
    { code: '4121', description: 'Taxis y limusinas' },
    { code: '4131', description: 'Líneas de autobús' },
    { code: '4214', description: 'Transporte de carga, mudanzas y almacenamiento' },
    { code: '4215', description: 'Servicios de mensajería y courier' },
    { code: '4225', description: 'Almacenamiento y bodegas públicas' },
    { code: '4411', description: 'Cruceros y líneas navieras' },
    { code: '4457', description: 'Alquiler y arrendamiento de embarcaciones' },
    { code: '4468', description: 'Marinas, servicios y suministros marinos' },
    { code: '4511', description: 'Aerolíneas y transporte aéreo' },
    { code: '4582', description: 'Aeropuertos, campos de vuelo y terminales aéreas' },
    { code: '4722', description: 'Agencias de viajes y operadores turísticos' },
    { code: '4784', description: 'Peajes y tarifas de puentes' },
    { code: '4789', description: 'Servicios de transporte (otros)' },
    { code: '4812', description: 'Equipos de telecomunicaciones y venta de teléfonos' },
    { code: '4814', description: 'Servicios de telecomunicaciones' },
    { code: '4816', description: 'Redes de computadoras y servicios de información' },
    { code: '4821', description: 'Servicios de telégrafo' },
    { code: '4829', description: 'Transferencias de dinero' },
    { code: '4899', description: 'Servicios de cable, satélite y televisión de pago' },
    { code: '4900', description: 'Servicios públicos – electricidad, gas, agua y saneamiento' },
    { code: '5013', description: 'Suministros y repuestos nuevos para vehículos' },
    { code: '5021', description: 'Muebles de oficina y comerciales' },
    { code: '5039', description: 'Materiales de construcción (otros)' },
    { code: '5044', description: 'Equipo fotográfico, de fotocopiado y microfilm' },
    { code: '5045', description: 'Computadoras, periféricos y software' },
    { code: '5046', description: 'Equipo comercial (otros)' },
    { code: '5047', description: 'Equipo y suministros médicos, dentales, oftálmicos y hospitalarios' },
    { code: '5051', description: 'Centros de servicio y oficinas de metales' },
    { code: '5065', description: 'Partes y equipos eléctricos' },
    { code: '5072', description: 'Equipo y suministros de ferretería' },
    { code: '5074', description: 'Equipo y suministros de plomería y calefacción' },
    { code: '5085', description: 'Suministros industriales (otros)' },
    { code: '5094', description: 'Piedras y metales preciosos, relojes y joyería' },
    { code: '5099', description: 'Bienes duraderos (otros)' },
    { code: '5111', description: 'Papelería, suministros de oficina y papel de impresión' },
    { code: '5122', description: 'Medicamentos, artículos de farmacia y droguería' },
    { code: '5131', description: 'Telas por pieza, artículos de mercería y otros textiles' },
    { code: '5137', description: 'Uniformes y ropa comercial para hombre, mujer y niños' },
    { code: '5139', description: 'Calzado comercial' },
    { code: '5169', description: 'Químicos y productos afines (otros)' },
    { code: '5172', description: 'Petróleo y productos derivados' },
    { code: '5192', description: 'Libros, periódicos y revistas' },
    { code: '5193', description: 'Productos de floristería y viveros' },
    { code: '5198', description: 'Pinturas, barnices y suministros' },
    { code: '5199', description: 'Bienes no duraderos (otros)' },
    { code: '5200', description: 'Tiendas de suministros para el hogar' },
    { code: '5211', description: 'Madera y materiales de construcción' },
    { code: '5231', description: 'Tiendas de vidrio, pintura y papel tapiz' },
    { code: '5251', description: 'Ferreterías' },
    { code: '5261', description: 'Viveros y tiendas de jardinería' },
    { code: '5271', description: 'Venta de casas móviles' },
    { code: '5300', description: 'Clubes de precios y ventas al por mayor' },
    { code: '5309', description: 'Tiendas libres de impuestos (duty free)' },
    { code: '5310', description: 'Tiendas de descuento' },
    { code: '5311', description: 'Tiendas por departamentos' },
    { code: '5331', description: 'Tiendas de variedades' },
    { code: '5399', description: 'Mercancía general (otros)' },
    { code: '5411', description: 'Supermercados y tiendas de abarrotes' },
    { code: '5422', description: 'Carnicerías y congeladores de alimentos' },
    { code: '5441', description: 'Dulcerías, confiterías y tiendas de nueces' },
    { code: '5451', description: 'Tiendas de productos lácteos' },
    { code: '5462', description: 'Panaderías y reposterías' },
    { code: '5499', description: 'Tiendas de alimentos especializados y minisúper (otros)' },
    { code: '5511', description: 'Concesionarios de autos y camiones nuevos y usados' },
    { code: '5521', description: 'Concesionarios de autos y camiones usados' },
    { code: '5531', description: 'Tiendas de repuestos y accesorios automotrices' },
    { code: '5532', description: 'Tiendas de llantas' },
    { code: '5533', description: 'Repuestos y accesorios automotrices' },
    { code: '5541', description: 'Estaciones de servicio (gasolineras)' },
    { code: '5542', description: 'Dispensadores automáticos de combustible' },
    { code: '5551', description: 'Venta de embarcaciones' },
    { code: '5561', description: 'Venta de casas rodantes y remolques recreativos' },
    { code: '5571', description: 'Venta de motocicletas' },
    { code: '5592', description: 'Venta de autocaravanas' },
    { code: '5598', description: 'Venta de motos de nieve' },
    { code: '5599', description: 'Venta de vehículos y equipo automotriz (otros)' },
    { code: '5611', description: 'Ropa y accesorios para hombres y niños' },
    { code: '5621', description: 'Tiendas de ropa de mujer' },
    { code: '5631', description: 'Accesorios y tiendas especializadas para mujer' },
    { code: '5641', description: 'Ropa para niños y bebés' },
    { code: '5651', description: 'Ropa para toda la familia' },
    { code: '5655', description: 'Ropa deportiva y de montar' },
    { code: '5661', description: 'Zapaterías' },
    { code: '5681', description: 'Peleterías' },
    { code: '5691', description: 'Tiendas de ropa para hombre y mujer' },
    { code: '5697', description: 'Sastrería, costura y arreglos' },
    { code: '5698', description: 'Tiendas de pelucas y postizos' },
    { code: '5699', description: 'Tiendas de ropa y accesorios (otros)' },
    { code: '5712', description: 'Muebles y artículos para el hogar' },
    { code: '5713', description: 'Tiendas de pisos y alfombras' },
    { code: '5714', description: 'Cortinas, tapicería y persianas' },
    { code: '5718', description: 'Chimeneas y accesorios' },
    { code: '5719', description: 'Tiendas especializadas de artículos para el hogar' },
    { code: '5722', description: 'Electrodomésticos' },
    { code: '5732', description: 'Tiendas de electrónica' },
    { code: '5733', description: 'Tiendas de música e instrumentos musicales' },
    { code: '5734', description: 'Tiendas de software' },
    { code: '5735', description: 'Tiendas de discos y música' },
    { code: '5811', description: 'Servicios de catering y banquetes' },
    { code: '5812', description: 'Restaurantes' },
    { code: '5813', description: 'Bares, cantinas, discotecas y clubes nocturnos' },
    { code: '5814', description: 'Comidas rápidas' },
    { code: '5815', description: 'Medios digitales – libros, películas y música' },
    { code: '5816', description: 'Juegos digitales' },
    { code: '5817', description: 'Aplicaciones digitales (excepto juegos)' },
    { code: '5818', description: 'Bienes digitales – grandes comercios' },
    { code: '5912', description: 'Farmacias' },
    { code: '5921', description: 'Licoreras – cerveza, vino y licores' },
    { code: '5931', description: 'Tiendas de artículos usados y de segunda mano' },
    { code: '5932', description: 'Tiendas de antigüedades' },
    { code: '5933', description: 'Casas de empeño' },
    { code: '5935', description: 'Chatarreras y desarmaderos' },
    { code: '5937', description: 'Reproducciones de antigüedades' },
    { code: '5940', description: 'Tiendas de bicicletas' },
    { code: '5941', description: 'Artículos deportivos' },
    { code: '5942', description: 'Librerías' },
    { code: '5943', description: 'Papelerías y artículos de oficina y escolares' },
    { code: '5944', description: 'Joyerías y relojerías' },
    { code: '5945', description: 'Jugueterías y tiendas de juegos' },
    { code: '5946', description: 'Tiendas de fotografía' },
    { code: '5947', description: 'Tiendas de regalos, tarjetas y souvenirs' },
    { code: '5948', description: 'Artículos de cuero y equipaje' },
    { code: '5949', description: 'Tiendas de telas, costura y mercería' },
    { code: '5950', description: 'Cristalería y artículos de vidrio' },
    { code: '5960', description: 'Marketing directo – seguros' },
    { code: '5962', description: 'Marketing directo – servicios de viaje' },
    { code: '5963', description: 'Ventas puerta a puerta' },
    { code: '5964', description: 'Marketing directo – catálogo' },
    { code: '5965', description: 'Marketing directo – catálogo y venta minorista combinados' },
    { code: '5966', description: 'Marketing directo – telemercadeo saliente' },
    { code: '5967', description: 'Marketing directo – telemercadeo entrante' },
    { code: '5968', description: 'Marketing directo – suscripciones' },
    { code: '5969', description: 'Marketing directo (otros)' },
    { code: '5970', description: 'Tiendas de arte y manualidades' },
    { code: '5971', description: 'Galerías y marchantes de arte' },
    { code: '5972', description: 'Tiendas de sellos y monedas' },
    { code: '5973', description: 'Artículos religiosos' },
    { code: '5975', description: 'Aparatos auditivos – venta y servicio' },
    { code: '5976', description: 'Artículos ortopédicos y prótesis' },
    { code: '5977', description: 'Cosméticos y tiendas de belleza' },
    { code: '5978', description: 'Máquinas de escribir – venta, alquiler y servicio' },
    { code: '5983', description: 'Distribuidores de combustible – carbón, leña, gas' },
    { code: '5992', description: 'Floristerías' },
    { code: '5993', description: 'Tabaquerías' },
    { code: '5994', description: 'Venta de periódicos y revistas' },
    { code: '5995', description: 'Tiendas de mascotas, alimentos y suministros' },
    { code: '5996', description: 'Piscinas y spas – venta y servicio' },
    { code: '5997', description: 'Máquinas de afeitar eléctricas – venta y servicio' },
    { code: '5998', description: 'Tiendas de campaña y toldos' },
    { code: '5999', description: 'Tiendas especializadas (otros)' },
    { code: '6010', description: 'Instituciones financieras – desembolso manual de efectivo' },
    { code: '6011', description: 'Instituciones financieras – cajeros automáticos' },
    { code: '6012', description: 'Instituciones financieras – mercancía y servicios' },
    { code: '6051', description: 'Instituciones no financieras – divisas, giros y cheques de viajero' },
    { code: '6211', description: 'Corredores de valores y bolsa' },
    { code: '6300', description: 'Seguros – ventas, suscripción y primas' },
    { code: '6513', description: 'Agentes y administradores de bienes raíces – alquileres' },
    { code: '6540', description: 'Recarga de tarjetas prepago' },
    { code: '7011', description: 'Hoteles, moteles y resorts' },
    { code: '7012', description: 'Tiempos compartidos' },
    { code: '7032', description: 'Campamentos deportivos y recreativos' },
    { code: '7033', description: 'Parques de casas rodantes y campamentos' },
    { code: '7210', description: 'Lavandería, limpieza y planchado' },
    { code: '7211', description: 'Lavanderías familiares y comerciales' },
    { code: '7216', description: 'Tintorerías' },
    { code: '7217', description: 'Limpieza de alfombras y tapicería' },
    { code: '7221', description: 'Estudios fotográficos' },
    { code: '7230', description: 'Salones de belleza y barberías' },
    { code: '7251', description: 'Reparación de calzado, limpieza de sombreros' },
    { code: '7261', description: 'Funerarias y crematorios' },
    { code: '7273', description: 'Servicios de citas y acompañamiento' },
    { code: '7276', description: 'Servicios de preparación de impuestos' },
    { code: '7277', description: 'Servicios de asesoría – deudas, matrimonio y personal' },
    { code: '7278', description: 'Clubes de compras y servicios de compras' },
    { code: '7296', description: 'Alquiler de ropa – disfraces y uniformes' },
    { code: '7297', description: 'Salones de masajes' },
    { code: '7298', description: 'Spas de salud y belleza' },
    { code: '7299', description: 'Servicios personales (otros)' },
    { code: '7311', description: 'Servicios de publicidad' },
    { code: '7321', description: 'Agencias de reporte de crédito al consumidor' },
    { code: '7333', description: 'Fotografía comercial, arte y gráficos' },
    { code: '7338', description: 'Servicios de fotocopiado y reproducción' },
    { code: '7339', description: 'Servicios de apoyo secretarial y taquigrafía' },
    { code: '7342', description: 'Exterminación y desinfección' },
    { code: '7349', description: 'Servicios de limpieza, mantenimiento y conserjería' },
    { code: '7361', description: 'Agencias de empleo y servicios de personal temporal' },
    { code: '7372', description: 'Programación, procesamiento de datos y diseño de sistemas' },
    { code: '7375', description: 'Servicios de recuperación de información' },
    { code: '7379', description: 'Mantenimiento y reparación de computadoras (otros)' },
    { code: '7392', description: 'Consultoría de gestión y relaciones públicas' },
    { code: '7393', description: 'Agencias de detectives, protección y seguridad' },
    { code: '7394', description: 'Alquiler y arrendamiento de equipo y mobiliario' },
    { code: '7395', description: 'Laboratorios fotográficos y de revelado' },
    { code: '7399', description: 'Servicios empresariales (otros)' },
    { code: '7512', description: 'Alquiler de automóviles' },
    { code: '7513', description: 'Alquiler de camiones y remolques' },
    { code: '7519', description: 'Alquiler de casas rodantes y vehículos recreativos' },
    { code: '7523', description: 'Parqueos y garajes' },
    { code: '7531', description: 'Talleres de enderezado y pintura' },
    { code: '7534', description: 'Reencauche y reparación de llantas' },
    { code: '7535', description: 'Talleres de pintura automotriz' },
    { code: '7538', description: 'Talleres de servicio automotriz' },
    { code: '7542', description: 'Lavado de autos' },
    { code: '7549', description: 'Servicio de grúas' },
    { code: '7622', description: 'Reparación de radio, televisión y equipo de sonido' },
    { code: '7623', description: 'Reparación de aire acondicionado y refrigeración' },
    { code: '7629', description: 'Reparación de electrodomésticos y equipo eléctrico' },
    { code: '7631', description: 'Reparación de relojes y joyería' },
    { code: '7641', description: 'Tapicería y restauración de muebles' },
    { code: '7692', description: 'Servicios de soldadura' },
    { code: '7699', description: 'Talleres de reparación y servicios relacionados (otros)' },
    { code: '7829', description: 'Producción y distribución de películas y video' },
    { code: '7832', description: 'Cines' },
    { code: '7841', description: 'Alquiler de videos' },
    { code: '7911', description: 'Salones y academias de baile' },
    { code: '7922', description: 'Productores teatrales y venta de entradas' },
    { code: '7929', description: 'Bandas, orquestas y entretenimiento (otros)' },
    { code: '7932', description: 'Billares y salas de pool' },
    { code: '7933', description: 'Boliches' },
    { code: '7941', description: 'Clubes deportivos, estadios y promotores deportivos' },
    { code: '7991', description: 'Atracciones turísticas y exhibiciones' },
    { code: '7992', description: 'Campos de golf públicos' },
    { code: '7993', description: 'Suministros para videojuegos y máquinas de diversión' },
    { code: '7994', description: 'Salas de videojuegos' },
    { code: '7995', description: 'Apuestas, loterías y casinos' },
    { code: '7996', description: 'Parques de diversiones, circos y ferias' },
    { code: '7997', description: 'Clubes de membresía – deportivos, recreativos y gimnasios' },
    { code: '7998', description: 'Acuarios, delfinarios y zoológicos' },
    { code: '7999', description: 'Servicios de recreación (otros)' },
    { code: '8011', description: 'Médicos y consultorios médicos' },
    { code: '8021', description: 'Dentistas y ortodoncistas' },
    { code: '8031', description: 'Osteópatas' },
    { code: '8041', description: 'Quiroprácticos' },
    { code: '8042', description: 'Optometristas y oftalmólogos' },
    { code: '8043', description: 'Ópticas y artículos ópticos' },
    { code: '8049', description: 'Podólogos y quiropodistas' },
    { code: '8050', description: 'Hogares de cuidado y enfermería' },
    { code: '8062', description: 'Hospitales' },
    { code: '8071', description: 'Laboratorios médicos y dentales' },
    { code: '8099', description: 'Servicios médicos y de salud (otros)' },
    { code: '8111', description: 'Servicios legales y abogados' },
    { code: '8211', description: 'Escuelas primarias y secundarias' },
    { code: '8220', description: 'Universidades, colegios y escuelas profesionales' },
    { code: '8241', description: 'Escuelas por correspondencia' },
    { code: '8244', description: 'Escuelas de negocios y secretariado' },
    { code: '8249', description: 'Escuelas técnicas y vocacionales' },
    { code: '8299', description: 'Escuelas y servicios educativos (otros)' },
    { code: '8351', description: 'Guarderías y cuidado infantil' },
    { code: '8398', description: 'Organizaciones benéficas y de servicio social' },
    { code: '8641', description: 'Asociaciones cívicas, sociales y fraternales' },
    { code: '8651', description: 'Organizaciones políticas' },
    { code: '8661', description: 'Organizaciones religiosas' },
    { code: '8675', description: 'Asociaciones automovilísticas' },
    { code: '8699', description: 'Organizaciones de membresía (otros)' },
    { code: '8734', description: 'Laboratorios de pruebas (no médicos)' },
    { code: '8911', description: 'Servicios de arquitectura, ingeniería y topografía' },
    { code: '8931', description: 'Contabilidad, auditoría y teneduría de libros' },
    { code: '8999', description: 'Servicios profesionales (otros)' },
    { code: '9211', description: 'Costas judiciales, incluye pensiones alimenticias' },
    { code: '9222', description: 'Multas' },
    { code: '9223', description: 'Pagos de fianzas y cauciones' },
    { code: '9311', description: 'Pago de impuestos' },
    { code: '9399', description: 'Servicios gubernamentales (otros)' },
    { code: '9402', description: 'Servicios postales – gobierno' },
];

export const mccLabel = (mcc: MccCode) => `${mcc.code} - ${mcc.description}`;
